import {
  callPost,
  callGet
} from "../../services/axios"

export const reportFilter = (
  filterList,
  limit,
  offset,
  primarySupplier,
  isMasterHeaderSelected,
  isChildHeaderSelected,
  isCardAcceptanceHeaderSelected,
  isAcceptanceFilterApplied,
  isSupDetailsFilterApplied,
  isChildSupDetailColChecked,
  isPayColChecked,
  IsPayFilterApplied,
  isMasterSupDetailsFilterApplied,
  isMasterSupDetailsColChecked,
  isChildColCheckedForMaster
) => async (dispatch, getState) => {
  const {
    auth: {
      token
    }
  } = getState()
  return callPost(`/api/report/filter`, {
    filterList,
    limit,
    offset,
    primarySupplier,
    isMasterHeaderSelected,
    isChildHeaderSelected,
    isCardAcceptanceHeaderSelected,
    isAcceptanceFilterApplied,
    isSupDetailsFilterApplied,
    isChildSupDetailColChecked,
    isPayColChecked,
    IsPayFilterApplied,
    isMasterSupDetailsFilterApplied,
    isMasterSupDetailsColChecked,
    isChildColCheckedForMaster
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}


export const createListSupplierReport = (
  filterList,
  limit,
  offset,
  primarySupplier,
  isMasterHeaderSelected,
  isChildHeaderSelected,
  isCardAcceptanceHeaderSelected,
  isAcceptanceFilterApplied,
  isSupDetailsFilterApplied,
  isChildSupDetailColChecked,
  isPayColChecked,
  IsPayFilterApplied,
  isMasterSupDetailsFilterApplied,
  isMasterSupDetailsColChecked,
  isChildColCheckedForMaster,
  isListSupDetailsFilterApplied,
  isListSupDetailsColChecked,
  isAcceptanceEmailFilterApplied,
  isAcceptanceEmailColChecked,
  isCcRemittanceFilterApplied,
  isCcPaymentFilterApplied,
  isCcRemittanceColChecked,
  isCcPaymentColChecked,
  visibleReportHeaders,
  tmpPartnerList,
  tmpCustomerList,
  isLastCalledDateFilterApplied,
  isLastCalledDateColChecked
) => async (dispatch, getState) => {

  const {
    auth: {
      token
    }
  } = getState()
  return callPost(`/api/report/createListSupplierReport`, {
    filterList,
    limit,
    offset,
    primarySupplier,
    isMasterHeaderSelected,
    isChildHeaderSelected,
    isCardAcceptanceHeaderSelected,
    isAcceptanceFilterApplied,
    isSupDetailsFilterApplied,
    isChildSupDetailColChecked,
    isPayColChecked,
    IsPayFilterApplied,
    isMasterSupDetailsFilterApplied,
    isMasterSupDetailsColChecked,
    isChildColCheckedForMaster,
    isListSupDetailsFilterApplied,
    isListSupDetailsColChecked,
    isAcceptanceEmailFilterApplied,
    isAcceptanceEmailColChecked,
    isCcRemittanceFilterApplied,
    isCcPaymentFilterApplied,
    isCcRemittanceColChecked,
    isCcPaymentColChecked,
    visibleReportHeaders,
    tmpPartnerList,
    tmpCustomerList,
    isLastCalledDateFilterApplied,
    isLastCalledDateColChecked
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const createChildSupplierReport = (
  filterList,
  limit,
  offset,
  primarySupplier,
  isMasterHeaderSelected,
  isChildHeaderSelected,
  isCardAcceptanceHeaderSelected,
  isAcceptanceFilterApplied,
  isSupDetailsFilterApplied,
  isChildSupDetailColChecked,
  isPayColChecked,
  IsPayFilterApplied,
  isMasterSupDetailsFilterApplied,
  isMasterSupDetailsColChecked,
  isChildColCheckedForMaster,
  isAcceptanceEmailFilterApplied,
  isAcceptanceEmailColChecked,
  isCcRemittanceFilterApplied,
  isCcPaymentFilterApplied,
  isCcRemittanceColChecked,
  isCcPaymentColChecked,
  visibleReportHeaders,
  isUserIdChildColChecked,
  tmpPartnerList,
  tmpCustomerList
) => async (dispatch, getState) => {
  const {
    auth: {
      token
    }
  } = getState()
  return callPost(`/api/report/createChildSupplierReport`, {
    filterList,
    limit,
    offset,
    primarySupplier,
    isMasterHeaderSelected,
    isChildHeaderSelected,
    isCardAcceptanceHeaderSelected,
    isAcceptanceFilterApplied,
    isSupDetailsFilterApplied,
    isChildSupDetailColChecked,
    isPayColChecked,
    IsPayFilterApplied,
    isMasterSupDetailsFilterApplied,
    isMasterSupDetailsColChecked,
    isChildColCheckedForMaster,
    isAcceptanceEmailFilterApplied,
    isAcceptanceEmailColChecked,
    isCcRemittanceFilterApplied,
    isCcPaymentFilterApplied,
    isCcRemittanceColChecked,
    isCcPaymentColChecked,
    visibleReportHeaders,
    isUserIdChildColChecked,
    tmpPartnerList,
    tmpCustomerList
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const createMasterSupplierReport = (
  filterList,
  limit,
  offset,
  primarySupplier,
  isMasterHeaderSelected,
  isChildHeaderSelected,
  isCardAcceptanceHeaderSelected,
  isAcceptanceFilterApplied,
  isSupDetailsFilterApplied,
  isChildSupDetailColChecked,
  isPayColChecked,
  IsPayFilterApplied,
  isMasterSupDetailsFilterApplied,
  isMasterSupDetailsColChecked,
  isChildColCheckedForMaster,
  isAcceptanceEmailFilterApplied,
  isAcceptanceEmailColChecked,
  isCcRemittanceFilterApplied,
  isCcPaymentFilterApplied,
  isCcRemittanceColChecked,
  isCcPaymentColChecked,
  visibleReportHeaders,
  isUserIdMasterColChecked,
  tmpPartnerList,
  tmpCustomerList,
  isParentOrganizationsChecked,
) => async (dispatch, getState) => {
  const {
    auth: {
      token
    }
  } = getState()
  return callPost(`/api/report/createMasterSupplierReport`, {
    filterList,
    limit,
    offset,
    primarySupplier,
    isMasterHeaderSelected,
    isChildHeaderSelected,
    isCardAcceptanceHeaderSelected,
    isAcceptanceFilterApplied,
    isSupDetailsFilterApplied,
    isChildSupDetailColChecked,
    isPayColChecked,
    IsPayFilterApplied,
    isMasterSupDetailsFilterApplied,
    isMasterSupDetailsColChecked,
    isChildColCheckedForMaster,
    isAcceptanceEmailFilterApplied,
    isAcceptanceEmailColChecked,
    isCcRemittanceFilterApplied,
    isCcPaymentFilterApplied,
    isCcRemittanceColChecked,
    isCcPaymentColChecked,
    visibleReportHeaders,
    isUserIdMasterColChecked,
    tmpPartnerList,
    tmpCustomerList,
    isParentOrganizationsChecked,
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}


export const getAcceptanceEmailsAndFeesForIds = (primarySupplier, primarySupplierIds) => async (dispatch, getState) => {
  const {
    auth: {
      token
    }
  } = getState()
  return callPost(`/api/report/getAcceptanceEmailsAndFeesForIds`, {
    primarySupplier,
    primarySupplierIds
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getCardAcceptanceAndPayments = (primarySupplier, masterIds) => async (dispatch, getState) => {
  const {
    auth: {
      user,
      token
    }
  } = getState()
  return callPost(`/api/report/getSupplierCardAcceptanceAndPayments`, {
    primarySupplier,
    masterIds
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const saveReport = (finalFilter, reportName, visibleReportHeaders, primarySupplier, partnerList, customerList) => async (dispatch, getState) => {
  const {
    auth: {
      token,
      user
    }
  } = getState()
  return callPost(`/api/report/saveReports`, {
    finalFilter,
    reportName,
    visibleReportHeaders,
    primarySupplier,
    user, partnerList, customerList
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}



export const getSavedReports = (limit, offset, search = {}) => async (dispatch, getState) => {
  const {
    auth: {
      token,
      user
    }
  } = getState()
  return callPost(`/api/report/getSavedReports`, {
    user,
    limit,
    offset,
    search
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const deleteReport = (id) => async (dispatch, getState) => {
  const {
    auth: {
      token,
      user
    }
  } = getState()
  return callPost(`/api/report/deleteReport`, {
    id
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getMasterAcceptanceAndCardAcceptance = (matchedSupplierId, isGetCardAcc, isGetPayment) => async (dispatch, getState) => {
  const {
    auth: {
      token,
      user
    }
  } = getState()
  return callPost(`/api/report/getMasterCardAcceptanceAndPaymentsByMatchedSupplierId`, {
    matchedSupplierId,
    isGetCardAcc,
    isGetPayment
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const shareReport = (emails, reportId) => async (dispatch, getState) => {
  const {
    auth: {
      token,
      user
    }
  } = getState()
  return callPost(`/api/report/shareReport`, {
    emails,
    reportId,
    user
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getSavedReportById = (reportId) => async (dispatch, getState) => {
  const {
    auth: {
      token,
      user
    }
  } = getState()
  return callPost(`/api/report/getSavedReportById`, {
    reportId,
    userId: user?.id
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getMySharedReports = () => async (dispatch, getState) => {
  const {
    auth: {
      token,
      user
    }
  } = getState()
  return callPost(`/api/report/getMySharedReports`, {
    userId: user?.id
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}




//SELECT suppliers.suppliername, suppliers.state, cardAcceptances.isAcceptAmericanExpress, cardAcceptances.amexProcessingFeeType, cardAcceptances.amexProcessingFeeValue, cardAcceptances.amexMinPayment FROM suppliers JOIN cardAcceptances ON cardAcceptances.supplierId = suppliers.id  AND cardAcceptances.isAcceptAmericanExpress=true AND cardAcceptances.amexProcessingFeeType= "$" AND cardAcceptances.amexProcessingFeeValue = 12 AND cardAcceptances.amexMinPayment >= 13  where suppliers.isMaster=true AND suppliers.masterId IS NULL AND suppliers.suppliername = 'Allied' 